import React from 'react';
import PropTypes from 'prop-types';
import { useObserver } from 'mobx-react';
import { Grid, Button } from '@material-ui/core';

import { useStore } from 'core/store/store.mobx';
import { Label } from 'core/components/label';

const BrandedTitleCarsWarning = ({ classes }) => {
  const { offer: store } = useStore();

  const onClick = () => {
    store.triggerOfferDialog(false);
    store.clearNewBrandedTitleNotification();
  };

  return useObserver(() => (
    <>
      <Label type="titleSecondary" className={classes.title}>
        Please review coverages on the vehicle(s) you just added
      </Label>
      <Label type="infoInnerTitle" className={classes.content}>
        This/These vehicle(s) only qualify for liability coverage with Branch because our title data sources indicate
        that they were rebuilt, restored, or were a manufacturer lemon buyback. Any selections for comprehensive or
        collision deductibles, roadside, loan/lease, rental coverage, rideshare coverage, or additional custom parts,
        have been removed. Please review these changes before continuing to other changes.
      </Label>

      <Grid container alignItems="center" className={classes.bottom}>
        <Button onClick={onClick} variant="contained" color="primary" className={classes.btn}>
          <Label className={classes.btnLabel}>Close</Label>
        </Button>
      </Grid>
    </>
  ));
};

BrandedTitleCarsWarning.propTypes = {
  classes: PropTypes.object.isRequired
};

export default BrandedTitleCarsWarning;
